function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-7-10h24v24H-7z"
}), React.createElement("path", {
  fill: "#102E8E",
  d: "M.512.512l4.276 4.276a.3.3 0 00.424 0L9.488.512A.3.3 0 009.276 0H.724a.3.3 0 00-.212.512z"
}));

var SvgIcArrowDown = function SvgIcArrowDown(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgMTAgNSI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0tNy0xMGgyNHYyNEgtN3oiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMTAyRThFIiBkPSJNLjUxMi41MTJsNC4yNzYgNC4yNzZhLjMuMyAwIDAgMCAuNDI0IDBMOS40ODguNTEyQS4zLjMgMCAwIDAgOS4yNzYgMEguNzI0YS4zLjMgMCAwIDAtLjIxMi41MTJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIcArrowDown as ReactComponent };